import React, {
    useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import Typography from '../Typography/CustomTypography';

const mediaTypes = { audio: 1, video: 2 };
const statusConvert = {
    0: '処理待ち中',
    1: '処理成功',
    2: '処理失敗',
};

export default function ReactPlayerCustome(props) {
    const { mediaType, status, ...rest } = props;
    const [params, setParams] = useState({ heightOfMedia: 360, urlMedia: '' });
    useEffect(() => {
        if (mediaType) {
            const heightOfMedia = mediaType === mediaTypes.audio ? 60 : 360;
            setParams((oldParams) => ({ ...oldParams, heightOfMedia }));
        }
    }, [mediaType]);

    return (
        <>
            <ReactPlayer
                controls
                config={{
                    attributes: {
                        controlsList: 'nodownload',
                        style: {
                            outline: 'none',
                            width: '100%',
                            height: '100%',
                        },
                    },
                    // forceAudio: mediaType === mediaTypes.audio,
                }}
                height={params.heightOfMedia}
                width="auto"
                {...rest}
            />
            { statusConvert[`${status}`] && (
                <Typography>
                    動画処理状態：
                    {statusConvert[`${status}`]}
                </Typography>
            )}
        </>
    );
}

ReactPlayerCustome.defaultProps = {
    mediaType: 1,
    status: -1,
};

ReactPlayerCustome.propTypes = {
    mediaType: PropTypes.number,
    status: PropTypes.number,
};
